import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertWebpToBmp() {
  return (
    <ImageConverterTemplate
      sourceFormat="WebP"
      targetFormat="BMP"
      acceptTypes=".webp,image/webp"
      slug="convert-webp-to-bmp"
      gradientColors="from-green-500 to-indigo-500"
      accentColor="blue"
    />
  );
}
